import { render, staticRenderFns } from "./InBody.vue?vue&type=template&id=51945084&scoped=true"
import script from "./InBody.vue?vue&type=script&lang=js"
export * from "./InBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51945084",
  null
  
)

export default component.exports